import { forwardRef, useContext } from "react";

import headingLevelContext from "./headingLevelContext";
import Typography from "./Typography.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default forwardRef(function Heading(props, ref) {
  props = useThemeProps({ props, name: "Heading" });
  let { variant, adjustLevel = 0, ...restProps } = props;
  let level = Math.min(6, useContext(headingLevelContext) + adjustLevel);
  let Element = `h${level}`;

  return (
    <Typography
      variant={variant || Element}
      as={Element}
      ref={ref}
      {...restProps}
    />
  );
});
